// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "trix"
import "@rails/actiontext"

// Trix includes text such as "Bold" inside toolbar buttons as an icon fallback.
// Our toolbar supplies compact controls via CSS, so remove that visible fallback
// text while retaining an accessible label and the browser tooltip.
document.addEventListener("trix-initialize", ({ target: editor }) => {
  const toolbar = editor.toolbarElement
  if (!toolbar) return

  toolbar.querySelectorAll(".trix-button").forEach((button) => {
    button.setAttribute("aria-label", button.title)
    button.replaceChildren()
  })
})
